import { useEffect, useRef } from "react";

export default function YildizArkaplan() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animId;
    let yildizlar = [];

    const boyutla = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    boyutla();
    window.addEventListener("resize", boyutla);

    for (let i = 0; i < 160; i++) {
      yildizlar.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.4 + 0.2,
        parlaklik: Math.random(),
        parlakHiz: Math.random() * 0.015 + 0.005,
      });
    }

    const ciz = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      yildizlar.forEach((y) => {
        y.parlaklik += y.parlakHiz;
        if (y.parlaklik > 1 || y.parlaklik < 0) y.parlakHiz *= -1;
        ctx.beginPath();
        ctx.arc(y.x, y.y, y.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,240,200,${0.3 + y.parlaklik * 0.7})`;
        ctx.fill();
      });
      animId = requestAnimationFrame(ciz);
    };
    ciz();

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener("resize", boyutla);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    />
  );
}